export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10104.a7956884.jpg";